var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCycling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00033 12.9999C5.28899 12.9999 6.33366 11.9552 6.33366 10.6666C6.33366 9.37792 5.28899 8.33325 4.00033 8.33325C2.71166 8.33325 1.66699 9.37792 1.66699 10.6666C1.66699 11.9552 2.71166 12.9999 4.00033 12.9999Z",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 12.9999C13.289 12.9999 14.3337 11.9552 14.3337 10.6666C14.3337 9.37792 13.289 8.33325 12.0003 8.33325C10.7117 8.33325 9.66699 9.37792 9.66699 10.6666C9.66699 11.9552 10.7117 12.9999 12.0003 12.9999Z",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.6666L9.33333 5.33325H6.66667L4 10.6666M6.66667 5.33325H10M6 10.6666H10.6667",
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCycling);
export default __webpack_public_path__ + "static/media/icon-cycling.dc5eaf73590dd82110d1b4ff999550bf.svg";
export { ForwardRef as ReactComponent };